import { AlertType } from '../enums/alertType';

export class Alert {
    public id: string;
    public jobId: string;
    public jobName: string;

    public start: Date;
    public end: Date;

    public startTime: string;
    public endTime: string;

    public threshold: number;
    public type: AlertType;

    public minDuration: number;
    public repeat: number;

    public recipients: Array<string>;
    public webAlertsEnabled: boolean;
    public language: string;
    public timeZoneId: string;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.id = json.id;
            this.jobId = json.jobId;
            this.jobName = json.jobName;
            this.start = new Date(json.start);
            this.end = new Date(json.end);
            this.startTime = json.startTime;
            this.endTime = json.endTime;
            this.threshold = json.threshold;
            this.type = json.type;
            this.minDuration = json.minDuration;
            this.repeat = json.repeat;
            this.recipients = json.recipients;
            this.webAlertsEnabled = json.webAlertsEnabled;
            this.language = json.language;
            this.timeZoneId = json.timeZoneId;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/alert.ts